<script setup>
import { useHead } from '@unhead/vue'
import { SOCIAL_SHARE_IMAGE, usePageHead } from '@composables/use-page-head'
import { computed } from 'vue'
import { useAuthStore } from '@state/stores/auth'
import Layout from '@layouts/main-layout'
import HomeUnAuth from '@router/views/homepage/homepage-unauth'
import HomeAuth from '@router/views/homepage/homepage-auth'

const authStore = useAuthStore()

const loggedIn = computed(() => authStore.loggedIn)

usePageHead({
    title: 'FRISKY — Underground Electronic Music Radio & DJ Mixes',
    description: 'Stream curated DJ mixes, live shows, and underground electronic music — house, techno, progressive, and more — on FRISKY since 2002.',
    image: SOCIAL_SHARE_IMAGE,
    canonical: 'https://frisky.fm/',
})

// The home title already carries the brand, so it opts out of app.vue's `| FRISKY` suffix.
useHead({ titleTemplate: '%s' })
</script>

<template>
    <Layout>
        <BaseContent class="content">
            <HomeAuth v-if="loggedIn" />
            <HomeUnAuth v-else />
        </BaseContent>
    </Layout>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
